import { type ReactElement } from 'react';
import { cn } from '@/lib/cn';
import { MasteryMeter } from '@/components/molecules/mastery-meter';
import type { VisualLevelDescriptor } from '@/lib/mastery';

type Props = {
  descriptor: VisualLevelDescriptor;
  selected: boolean;
  onSelect: () => void;
};

function handleKeyActivation(event: React.KeyboardEvent, onSelect: () => void): void {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onSelect();
  }
}

export function MasteryOptionCard({ descriptor, selected, onSelect }: Props): ReactElement {
  const { level, blurb } = descriptor;

  return (
    <div
      role="radio"
      aria-checked={selected}
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => handleKeyActivation(e, onSelect)}
      className={cn(
        'flex flex-col gap-2 rounded-[var(--r-sm)] border p-4 cursor-pointer transition-all',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]',
        'focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-surface)]',
        selected
          ? 'border-[var(--brand)] bg-[var(--brand)]/5 text-[var(--ink)]'
          : 'border-[var(--rule)] bg-[var(--bg-surface)] text-[var(--ink)] hover:border-[var(--brand)]',
      )}
    >
      <MasteryMeter level={level} showLabel={true} size="sm" />
      <p className="text-xs text-[var(--ink-3)]">{blurb}</p>
    </div>
  );
}
